module.exports = __webpack_public_path__ + "img/cashbot-hd.da4aa697.png";